export const COLLECTION_DETAILS_FORM_ID = Symbol("collection-details-form-id");
export const COLLECTION_CREATE_FORM_ID = Symbol("collection-create-form-id");
